import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warn",
  "use": "icon-warn-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warn\"><path d=\"M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2Zm.039 13.077a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM12 6.574a.961.961 0 0 0-.96.999l.232 5.83a.767.767 0 0 0 .766.736.76.76 0 0 0 .76-.737l.172-5.829v-.029a.97.97 0 0 0-.97-.97Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol